import View from "./View.js";
import winnersItemView from "./winnersItemView.js";
import icons from "url:../../img/BBA25-sprite.svg";

class WinnersView extends View {
	_parentElement = document.querySelector(".winners");
	_errorMessage = "No winners announced! Please try again.";
	_message = "";

	_generateMarkup() {
		let markup = '<h2 class="heading-2">Uzvarētāji</h2>';

		const winners = this._data.winners.map((result) => winnersItemView.render(result, false)).join("");

		markup += `
                <div class="container">
                    <div class="winners__content">
						${winners}
                    </div>
                </div>
                `;

		return markup;
	}

	addHandlerRender(handler) {
		handler();
	}
}

export default new WinnersView();
